import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getClassRestriction = ({ courseId }) =>
  httpClient.get(apis.getClassRestriction({ courseId }), {
    ignore: true,
    ignoreLoading: true,
  });
